// CDN Base URL for assets
export const CDN_BASE_URL = 'https://cdnsm.swipey.ai/prelander/createsexfriend';
export const CDN_URL = 'https://cdnsm.swipey.ai';
// Application Steps
export const QUIZ_STEPS = [
  'welcome',
  'step1',
  'step2',
  'step2_body',
  'step2_breast',
  'step2_ass',
  'step3',
  // 'step3_hair',
  'step4',
  'step4_5',
  'step5',
  'loading',
  'createAccount',
  'login',
];
export const QUIZ_STEPS_HENTAI = [
  'welcome',
  'step1',
  'step2',
  'step2_body',
  'step2_breast',
  'step2_ass',
  'step3',
  // 'step3_hair',
  'step4',
  'step4_5',
  'step5',
  'loading',
  'createAccount',
  'login',
];
export const QUIZ_STEPS_PORN = [
  'welcome',
  'step1',
  'step2',
  'step2_body',
  'step2_breast',
  'step2_ass',
  'step3',
  // 'step3_hair',
  'step4',
  'step4_5',
  'step5',
  'loading',
  'createAccount',
  'login',
];

// Steps that should not show progress stepper and not be counted in total
export const HIDDEN_STEPS = [11, 12, 13]; // loading, createAccount, login

// Local Storage Keys
export const STORAGE_KEYS = {
  AI_GIRLFRIEND_SELECTIONS: 'aiGirlfriendSelections',
  AI_GIRLFRIEND_SELECTIONS_HENTAI: 'aiGirlfriendSelectionsHentai',
  AI_GIRLFRIEND_SELECTIONS_PORN: 'aiGirlfriendSelectionsPorn',
  TRACKING_PARAMS: 'trackingParams',
};

// ---- GrowthBook media override (createsexfriend-attributes) ----
// We only let GrowthBook override ASSET URLs (videos / images), never labels,
// icons or flags. The flag value is shaped by mode:
//   { Realistic: { ethnicity: { Caucasian: { video, extendVideo, image, ... } } },
//     Anime:     { ... } }
// Anything omitted falls back to the built-in default (or the auto Anime path
// transform below), so a variation can change a single video and nothing else.
const MEDIA_KEYS = ['image', 'video', 'extendVideo', 'leftGirl', 'rightGirl', 'audio'];

let quizMediaOverride = null;

// Set from GrowthBookContext before children render. `null` → defaults only.
//
// Accepts two shapes, mirroring createsexfriend-content:
//   legacy (flat) { Realistic: {...}, Anime: {...} }
//   branched      { nsfw: { Realistic, Anime }, sfw: { Realistic, Anime } }
// A branched value is narrowed to the arm for the active `?variation=`, so the
// value currently live in GrowthBook keeps working untouched.
export const setQuizMediaOverride = (value, variation = 'nsfw') => {
  if (!value || typeof value !== 'object') {
    quizMediaOverride = null;
    return;
  }
  const branched =
    typeof value.nsfw === 'object' || typeof value.sfw === 'object';
  const resolved = branched ? value[variation] : value;
  quizMediaOverride =
    resolved && typeof resolved === 'object' ? resolved : null;
};

// Overlay GB asset URLs (for the given mode) onto already-resolved options,
// matching by option `value`. Any string media field is applied; `''` clears it.
// Map a quiz step to the key used inside the GrowthBook `createsexfriend-attributes`
// override object. Most steps map 1:1; the new visual-only personality set
// (personalityV2) reads its asset overrides from `attributes[style].personality`.
const MEDIA_OVERRIDE_STEP_ALIASES = {
  personalityV2: 'personality',
};

const overlayMediaOverride = (options, step, styleKey) => {
  const overrideStep = MEDIA_OVERRIDE_STEP_ALIASES[step] || step;
  const stepOverride = quizMediaOverride && quizMediaOverride[styleKey]
    ? quizMediaOverride[styleKey][overrideStep]
    : null;
  if (!stepOverride) return options;

  return options.map((item) => {
    const itemOverride = stepOverride[item.value];
    if (!itemOverride || typeof itemOverride !== 'object') return item;

    const patch = {};
    MEDIA_KEYS.forEach((key) => {
      const value = itemOverride[key];
      if (typeof value !== 'string') return;
      // An explicit empty string CLEARS the built-in asset — it is not ignored.
      // The SFW arm needs this: the createsexfriend-white CDN folder carries the
      // images but none of attribute_videos/**, and the step components fall back
      // to `image` whenever `video` is falsy. Without a way to clear it, the NSFW
      // video baked into the defaults would keep playing on the SFW arm.
      patch[key] = value;
    });
    return Object.keys(patch).length ? { ...item, ...patch } : item;
  });
};

export const getQuizOptionsData = (step, selectedStyle = 'Realistic') => {
  const options = DEFAULT_QUIZ_OPTIONS_DATA[step] || [];
  const styleKey = selectedStyle === 'Anime' ? 'Anime' : 'Realistic';

  // personalityV2 is a visual-only set whose defaults are local mock images
  // (/assets/personality/*.png). We never auto-rewrite these to a CDN Anime
  // folder — real per-style art arrives only via the GB override overlay.
  if (styleKey !== 'Anime' || step === 'personalityV2') {
    return overlayMediaOverride(options, step, styleKey);
  }

  // If anime style is selected, update paths to use Anime folder
  {
    const animeOptions = options.map((item) => {
      const updatePath = (path) => {
        if (!path) return path;

        // If already has "/Anime/" — don't change
        if (path.includes('/Anime/')) return path;

        // Convert CDN paths to Anime versions
        if (path.startsWith(CDN_BASE_URL)) {
          const fileName = path.split('/').pop();
          return `${CDN_BASE_URL}/Anime/${fileName}`;
        }

        // Convert old local asset paths to Anime versions
        const parts = path.split('/assets/');
        if (parts.length > 1) {
          return `${CDN_BASE_URL}/Anime/${parts[1]}`;
        }

        return path;
      };

      const updateVideoPath = (path) => {
        if (!path) return path;

        // If already has "_Anime" — don't change
        if (path.includes('_Anime')) return path;

        // Add _Anime suffix before file extension for all video paths
        const lastDotIndex = path.lastIndexOf('.');
        if (lastDotIndex !== -1) {
          const result =
            path.substring(0, lastDotIndex) +
            '_Anime' +
            path.substring(lastDotIndex);
          return result;
        }

        return path;
      };

      return {
        ...item,
        image: updatePath(item.image),
        leftGirl: updatePath(item.leftGirl),
        rightGirl: updatePath(item.rightGirl),
        video: updateVideoPath(item.video),
        extendVideo: updateVideoPath(item.extendVideo),
      };
    });

    // GB Anime-mode assets win over the auto-derived `/Anime/` paths.
    return overlayMediaOverride(animeOptions, step, styleKey);
  }
};
// Quiz Options Data — the built-in defaults. These are the fallback used when the
// GrowthBook `createsexfriend-attributes` flag is OFF or omits a given category.
const DEFAULT_QUIZ_OPTIONS_DATA = {
  // Step 0 - Welcome (AI Girlfriend Type)

  porn: [
    {
      value: 'College student',
      text: 'porn.collegestudent',
      image: `${CDN_BASE_URL}/Porn/collegestudent.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Dominatrix',
      text: 'porn.dominatrix',
      image: `${CDN_BASE_URL}/Porn/dominatrix.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Milf',
      text: 'porn.milf',
      image: `${CDN_BASE_URL}/Porn/milf.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Nurse',
      text: 'porn.nurse',
      image: `${CDN_BASE_URL}/Porn/nurse.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Pornstar',
      text: 'porn.pornstar',
      image: `${CDN_BASE_URL}/Porn/pornstar.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Secretary',
      text: 'porn.secretary',
      image: `${CDN_BASE_URL}/Porn/secretary.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Step sister',
      text: 'porn.stepsister',
      image: `${CDN_BASE_URL}/Porn/stepsister.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Teacher',
      text: 'porn.teacher',
      image: `${CDN_BASE_URL}/Porn/teacher.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Yoga instructor',
      text: 'porn.yogainstructor',
      image: `${CDN_BASE_URL}/Porn/yogainstructor.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Maid',
      text: 'porn.maid',
      image: `${CDN_BASE_URL}/Porn/maid.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Goth girl',
      text: 'porn.gothgirl',
      image: `${CDN_BASE_URL}/Porn/gothgirl.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
    {
      value: 'Princess',
      text: 'porn.princess',
      image: `${CDN_BASE_URL}/Porn/princess.webp`,
      alt: 'Porn AI',
      hasIcon: true,
    },
  ],

  hentai: [
    {
      value: 'Tentacles',
      text: 'hentai.tentacles',
      image: `${CDN_BASE_URL}/Hentai/tentacles.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Teacher',
      text: 'hentai.teacher',
      image: `${CDN_BASE_URL}/Hentai/teacher.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'College student',
      text: 'hentai.collegeStudent',
      image: `${CDN_BASE_URL}/Hentai/collegestudent.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Nekomimi',
      text: 'hentai.nekomimi',
      image: `${CDN_BASE_URL}/Hentai/nekomimi.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Futanari',
      text: 'hentai.futanari',
      image: `${CDN_BASE_URL}/Hentai/futanari.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Milf',
      text: 'hentai.milf',
      image: `${CDN_BASE_URL}/Hentai/milf.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Femdom',
      text: 'hentai.femdom',
      image: `${CDN_BASE_URL}/Hentai/femdom.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Pregnant',
      text: 'hentai.pregnant',
      image: `${CDN_BASE_URL}/Hentai/pregnant.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Nurse',
      text: 'hentai.nurse',
      image: `${CDN_BASE_URL}/Hentai/nurse.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Fantasy',
      text: 'hentai.fantasy',
      image: `${CDN_BASE_URL}/Hentai/fantasy.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Dandere',
      text: 'hentai.dandere',
      image: `${CDN_BASE_URL}/Hentai/dandere.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
    {
      value: 'Idol',
      text: 'hentai.idol',
      image: `${CDN_BASE_URL}/Hentai/idol.webp`,
      alt: 'Hentai AI',
      hasIcon: true,
    },
  ],

  welcome: [
    {
      value: 'Realistic',
      text: 'realistic',
      image: `${CDN_BASE_URL}/Realistic/step0-image.jpg`,
      alt: 'Realistic AI Girlfriend',
      hasIcon: true,
    },
    {
      value: 'Anime',
      text: 'anime',
      image: `${CDN_BASE_URL}/Anime/step0-image.jpg`,
      alt: 'Anime AI Girlfriend',
      hasIcon: true,
    },
  ],

  // Step 1 - Ethnicity
  ethnicity: [
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/euroLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/euroRight.png`,
      value: 'Caucasian',
      text: 'ethnicity.caucasian',
      image: `${CDN_BASE_URL}/Realistic/step1-image1.png`,
      video: `${CDN_BASE_URL}/attribute_videos/ethnicity/White.mp4`,
      extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_White.mp4`,
      alt: 'Caucasian',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/asianLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/asianRight.png`,
      value: 'Asian',
      text: 'ethnicity.asian',
      image: `${CDN_BASE_URL}/Realistic/step1-image2.png`,
      video: `${CDN_BASE_URL}/attribute_videos/ethnicity/Asian.mp4`,
      extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_Asian.mp4`,
      alt: 'Asian',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/ArabLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/ArabRight.png`,
      value: 'Mid.Eastern',
      text: 'ethnicity.arab',
      image: `${CDN_BASE_URL}/Realistic/step1-image3.png`,
      video: `${CDN_BASE_URL}/attribute_videos/ethnicity/Arab.mp4`,
      extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_Arab.mp4`,
      alt: 'Arab',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/africanLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/africanRight.png`,
      value: 'African',
      text: 'ethnicity.african',
      image: `${CDN_BASE_URL}/Realistic/step1-image4.png`,
      video: `${CDN_BASE_URL}/attribute_videos/ethnicity/African.mp4`,
      extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_African.mp4`,
      alt: 'African',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/latinaLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/latinaRight.png`,
      value: 'Latina',
      text: 'ethnicity.latina',
      image: `${CDN_BASE_URL}/Realistic/step1-image5.png`,
      video: `${CDN_BASE_URL}/attribute_videos/ethnicity/Latina.mp4`,
      extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_Latina.mp4`,
      alt: 'Latina',
      hasIcon: true,
    },
  ],

  // Step 2 - Body Type
  bodyType: [
    {
      value: 'Slim',
      text: 'bodyType.slim',
      image: `${CDN_BASE_URL}/Realistic/step2-body1.png`,
      video: `${CDN_BASE_URL}/attribute_videos/body/Petite_body.mp4`,
      alt: 'Slim body type',
      hasIcon: true,
    },
    {
      value: 'Athletic',
      text: 'bodyType.athletic',
      image: `${CDN_BASE_URL}/Realistic/step2-body2.png`,
      video: `${CDN_BASE_URL}/attribute_videos/body/Toned_body.mp4`,
      alt: 'Athletic body type',
      hasIcon: true,
    },
    {
      value: 'Average',
      text: 'bodyType.average',
      image: `${CDN_BASE_URL}/Realistic/step2-body3.png`,
      video: `${CDN_BASE_URL}/attribute_videos/body/Medium_body.mp4`,
      alt: 'Average body type',
      hasIcon: true,
    },
    {
      value: 'Voluptuous',
      text: 'bodyType.curvy',
      image: `${CDN_BASE_URL}/Realistic/step2-body4.png`,
      video: `${CDN_BASE_URL}/attribute_videos/body/Chubby_body.mp4`,
      alt: 'Curvy body type',
      hasIcon: true,
    },
  ],

  // Step 2 - Breast Size
  breastSize: [
    {
      value: 'Small (B)',
      text: 'breastSize.small',
      image: `${CDN_BASE_URL}/Realistic/step2-breast1.png`,
      video: `${CDN_BASE_URL}/attribute_videos/breast/Small_boobs.mp4`,
      alt: 'Small breast size',
      hasIcon: true,
    },
    {
      value: 'Medium (C)',
      text: 'breastSize.medium',
      image: `${CDN_BASE_URL}/Realistic/step2-breast2.png`,
      video: `${CDN_BASE_URL}/attribute_videos/breast/Medium_boobs.mp4`,
      alt: 'Medium breast size',
      hasIcon: true,
    },
    {
      value: 'Large (D)',
      text: 'breastSize.large',
      image: `${CDN_BASE_URL}/Realistic/step2-breast3.png`,
      video: `${CDN_BASE_URL}/attribute_videos/breast/Big_boobs.mp4`,
      alt: 'Large breast size',
      hasIcon: true,
    },
    {
      value: 'Huge (DD)',
      text: 'breastSize.huge',
      image: `${CDN_BASE_URL}/Realistic/step2-breast4.png`,
      video: `${CDN_BASE_URL}/attribute_videos/breast/Huge_tits.mp4`,
      alt: 'Huge breast size',
      hasIcon: true,
    },
  ],

  // Step 2 - Booty Size
  buttSize: [
    {
      value: 'Small',
      text: 'buttSize.small',
      image: `${CDN_BASE_URL}/Realistic/step2-booty1.png`,
      video: `${CDN_BASE_URL}/attribute_videos/booty/Skinny_ass.mp4`,
      alt: 'Small booty size',
      hasIcon: true,
    },
    {
      value: 'Medium',
      text: 'buttSize.medium',
      image: `${CDN_BASE_URL}/Realistic/step2-booty2.png`,
      video: `${CDN_BASE_URL}/attribute_videos/booty/Medium_ass.mp4`,
      alt: 'Medium booty size',
      hasIcon: true,
    },
    {
      value: 'Athletic',
      text: 'buttSize.athletic',
      image: `${CDN_BASE_URL}/Realistic/step2-booty3.png`,
      video: `${CDN_BASE_URL}/attribute_videos/booty/Toned_ass.mp4`,
      alt: 'Athletic booty size',
      hasIcon: true,
    },
    {
      value: 'Large',
      text: 'buttSize.large',
      image: `${CDN_BASE_URL}/Realistic/step2-booty4.png`,
      video: `${CDN_BASE_URL}/attribute_videos/booty/Huge_ass.mp4`,
      alt: 'Large booty size',
      hasIcon: true,
    },
  ],

  // Step 3 - Hair Color
  hairColor: [
    // {
    //   value: 'Black',
    //   text: 'hairColor.black',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hair3.png`,
    //   alt: 'Black hair',
    //   hasIcon: true,
    // },
    {
      value: 'Brown',
      text: 'hairColor.brunette',
      image: `${CDN_BASE_URL}/Realistic/step3-hair2.png`,
      alt: 'Brunette hair',
      hasIcon: true,
    },
    {
      value: 'Blonde',
      text: 'hairColor.blonde',
      image: `${CDN_BASE_URL}/Realistic/step3-hair1.png`,
      alt: 'Blonde hair',
      hasIcon: true,
    },
    // {
    //   value: 'Pink',
    //   text: 'hairColor.pink',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hair4.png`,
    //   alt: 'Pink hair',
    //   hasIcon: true,
    // },
    {
      value: 'Red',
      text: 'hairColor.redhead',
      image: `${CDN_BASE_URL}/Realistic/step3-hair5.png`,
      alt: 'Redhead hair',
      hasIcon: true,
    },
  ],

  // Step 3 - Hair Style
  hairStyle: [
    {
      value: 'Straight',
      text: 'hairStyle.straight',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle1.png`,
      alt: 'Straight hair style',
      hasIcon: true,
    },
    // {
    //   value: 'Wavy',
    //   text: 'hairStyle.wavy',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle2.png`,
    //   alt: 'Wavy hair style',
    //   hasIcon: true,
    // },
    // {
    //   value: 'Braids',
    //   text: 'hairStyle.braids',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle3.png`,
    //   alt: 'Braids hair style',
    //   hasIcon: true,
    // },
    {
      value: 'Bun',
      text: 'hairStyle.bun',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle4.png`,
      alt: 'Bun hair style',
      hasIcon: true,
    },
    // {
    //   value: 'Curly',
    //   text: 'hairStyle.curly',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle5.png`,
    //   alt: 'Curly hair style',
    //   hasIcon: true,
    // },
    {
      value: 'Ponytail',
      text: 'hairStyle.ponytail',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle6.png`,
      alt: 'Ponytail hair style',
      hasIcon: true,
    },
  ],

  // Step 3 - Eye Color
  eyeColor: [
    {
      value: 'Brown',
      text: 'eyeColor.brown',
      image: `${CDN_BASE_URL}/Realistic/step3-eye2.png`,
      alt: 'Brown eyes',
      hasIcon: true,
    },
    {
      value: 'Blue',
      text: 'eyeColor.blue',
      image: `${CDN_BASE_URL}/Realistic/step3-eye1.png`,
      alt: 'Blue eyes',
      hasIcon: true,
    },
    {
      value: 'Green',
      text: 'eyeColor.green',
      image: `${CDN_BASE_URL}/Realistic/step3-eye3.png`,
      alt: 'Green eyes',
      hasIcon: true,
    },
  ],

  // Step 4 - Voice
  voice: [
    {
      value: 'Voice 3',
      text: 'voice.teen',
      icon: '😋',
      audio: `${CDN_BASE_URL}/sounds/voice2.mp3`,
      hasIcon: true,
    },
    {
      value: 'Voice 4',
      text: 'voice.soft',
      icon: '😌',
      audio: `${CDN_BASE_URL}/sounds/voice3.mp3`,
      hasIcon: true,
    },
    {
      value: 'Voice 5',
      text: 'voice.mature',
      icon: '😈',
      audio: `${CDN_BASE_URL}/sounds/voice4.mp3`,
      hasIcon: true,
    },
  ],

  // Step 4 - Relationships
  personality: [
    {
      value: 'stepSis',
      text: 'personality.stepSis',
      icon: 'stepSis',
      description: 'Close family bond',
      hasIcon: true,
    },
    {
      value: 'stepMom',
      text: 'personality.stepMom',
      icon: 'stepMom',
      description: 'Caring and nurturing',
      hasIcon: true,
    },
    {
      value: 'girlfriend',
      text: 'personality.girlfriend',
      icon: 'girlfriend',
      description: 'Romantic and caring',
      hasIcon: true,
    },
  ],

  // Step 4 - Personality V2 (createsexfriend-isPersonality flag).
  // Visual-only set: these values are NOT mapped to the `relationship` API
  // attribute. Default images are local mocks; real per-style art can be
  // supplied via GrowthBook `createsexfriend-attributes[style].personality`.
  personalityV2: [
    {
      value: 'playful',
      label: 'Playful',
      image: '/assets/personality/playful.png',
    },
    {
      value: 'nympho',
      label: 'Nympho',
      image: '/assets/personality/nympho.png',
    },
    {
      value: 'submissive',
      label: 'Submissive',
      image: '/assets/personality/submissive.png',
    },
    {
      value: 'dominant',
      label: 'Dominant',
      image: '/assets/personality/dominant.png',
    },
  ],

  // Legacy steps for backward compatibility
  age: [
    { value: '18-24', text: '18-24' },
    { value: '25-35', text: '25-34' },
    { value: '35-44', text: '35-44' },
    { value: '45+', text: '45+' },
  ],

  useAI: [
    {
      value: '1',
      text: 'I use ChatGPT to help with simple tasks',
      image: '/assets/1.webp',
      alt: 'ChatGPT user',
      hasIcon: true,
    },
    {
      value: '2',
      text: 'I actively explore AI including image and video generation',
      image: '/assets/2.webp',
      alt: 'AI explorer',
      hasIcon: true,
    },
    {
      value: '3',
      text: 'I experiment with AI tools, can write prompts and use it for coding',
      image: '/assets/3.webp',
      alt: 'AI experimenter',
      hasIcon: true,
      defaultChecked: true,
    },
    {
      value: '4',
      text: 'I have no experience with AI',
      image: '/assets/4.webp',
      alt: 'AI beginner',
      hasIcon: true,
    },
  ],

  friendAI: [
    { value: '1', text: 'Having fun' },
    { value: '2', text: 'Staying motivated and focused' },
    { value: '3', text: 'Learning new skills' },
    { value: '4', text: 'Emotional support and advice' },
    { value: '5', text: 'Creative ideas and brainstorming' },
  ],
};

// Public name kept for the many direct importers. Text/labels/icons always come
// from these built-in defaults — only media assets are overridable via GrowthBook.
export const QUIZ_OPTIONS_DATA = DEFAULT_QUIZ_OPTIONS_DATA;

export const growthBookInstances = {
  'realistic-home-video':
    'prelander/createsexfriend/Realistic/realistic_createsexfriend_2.mp4',
  'realistic-home-poster':
    'prelander/createsexfriend/Realistic/step0-image.jpg',
  'anime-home-poster': 'prelander/createsexfriend/Anime/step0-image.jpg',
  'anime-home-video':
    'prelander/createsexfriend/Anime/anime_createsexfriend.mp4',
  'realistic-auth-video':
    'prelander/createsexfriend/Realistic/auth_realistic.mp4',
  'realistic-auth-photo':
    'prelander/createsexfriend/Realistic/first_frame_realistic.jpg',
  'anime-auth-video': 'prelander/createsexfriend/Anime/auth_anime.mp4',
  'anime-auth-photo': 'prelander/createsexfriend/Anime/first_frame_anime.jpg',
  'realistic-auth-video2':
    'prelander/createsexfriend/Realistic/auth_realistic_2.mp4',
  'realistic-auth-photo2':
    'prelander/createsexfriend/Realistic/first_frame_realistic_2.jpg',
  'anime-auth-video2': 'prelander/createsexfriend/Anime/auth_anime_2.mp4',
  'anime-auth-photo2':
    'prelander/createsexfriend/Anime/first_frame_anime_2.jpg',
};

// ---- NSFW / SFW content branches (createsexfriend-content) ----
//
// The flag accepts two shapes:
//
//   legacy (flat)  { 'realistic-home-video': '...', ... }
//   branched       { name: '...', nsfw: { ...media }, sfw: { ...media } }
//
// A branched value picks the arm for the active `?variation=`; a flat value is
// NSFW media, so it is used as-is on the NSFW arm only — the value currently
// live in GrowthBook keeps working untouched until it is swapped for the
// branched one.
//
// Whenever the SFW arm is active and the flag carries no `sfw` field (a flat
// payload, or a branched one with only `nsfw`), the local SFW config below wins
// outright — the arm must never render the NSFW paths the flag carries.
//
// Both shapes are merged OVER the built-in defaults, so a partial payload can
// change a single video without blanking every other key.

// SFW defaults — the createsexfriend-white asset folder. Used when the flag is
// absent or its `sfw` branch omits a key, so `?variation=sfw` renders SFW media
// even before the branched GrowthBook value is published.
export const SFW_CONTENT_DEFAULTS = {
  'realistic-home-video':
    'prelander/createsexfriend-white/Realistic/realistic_createsexfriend_2.mp4',
  'realistic-home-poster':
    'prelander/createsexfriend-white/Realistic/step0-image.jpg',
  'anime-home-poster': 'prelander/createsexfriend-white/Anime/step0-image.jpg',
  'anime-home-video':
    'prelander/createsexfriend-white/Anime/anime_createsexfriend.mp4',
  'realistic-auth-video':
    'prelander/createsexfriend-white/Realistic/auth_realistic.mp4',
  'realistic-auth-photo':
    'prelander/createsexfriend-white/Realistic/first_frame_realistic.jpg',
  'anime-auth-video': 'prelander/createsexfriend-white/Anime/auth_anime.mp4',
  'anime-auth-photo':
    'prelander/createsexfriend-white/Anime/first_frame_anime.jpg',
  'realistic-auth-video2':
    'prelander/createsexfriend-white/Realistic/auth_realistic_2.mp4',
  'realistic-auth-photo2':
    'prelander/createsexfriend-white/Realistic/first_frame_realistic_2.jpg',
  'anime-auth-video2': 'prelander/createsexfriend-white/Anime/auth_anime_2.mp4',
  'anime-auth-photo2':
    'prelander/createsexfriend-white/Anime/first_frame_anime_2.jpg',
};

export const CONTENT_DEFAULTS_BY_VARIATION = {
  nsfw: growthBookInstances,
  sfw: SFW_CONTENT_DEFAULTS,
};

const isBranchedContent = (raw) =>
  !!raw &&
  typeof raw === 'object' &&
  (typeof raw.nsfw === 'object' || typeof raw.sfw === 'object');

// Resolve the media map the app should render for `variation`.
//   raw: the raw createsexfriend-content flag value (may be null/undefined).
// `name` is kept at the top level of a branched payload and preserved here — it
// is forwarded to analytics as `lander-content`.
export const resolveContentBranch = (raw, variation = 'nsfw') => {
  const defaults =
    CONTENT_DEFAULTS_BY_VARIATION[variation] || growthBookInstances;

  if (!raw || typeof raw !== 'object') return defaults;

  const name = raw.name ? { name: raw.name } : {};
  const branch = raw[variation];

  // No branch for the active arm — either a flat (NSFW) payload seen from the
  // SFW arm, or a branched payload that omits this arm. Either way the flag has
  // nothing to say about it, so the local defaults are used untouched rather
  // than merged with the other arm's media.
  if (!branch || typeof branch !== 'object') {
    if (variation === 'sfw') return { ...defaults, ...name };

    // NSFW arm: a flat payload IS the nsfw media, so it still merges over the
    // defaults. `isSFWOverride` is a top-level CONTROL field (it forces the SFW
    // arm — see utils/variation) and is stripped so it never lands in the map.
    if (isBranchedContent(raw)) return { ...defaults, ...name };
    const { isSFWOverride, ...flat } = raw;
    return { ...defaults, ...flat };
  }

  return { ...defaults, ...branch, ...name };
};

// CSS Variables
export const CSS_VARIABLES = {
  // Colors
  colors: {
    primary: '#8350cb',
    secondary: '#fe6283',
    pinkAccent: '#FE6283',
    white: '#ffffff',
    semiTransparentWhite: 'rgba(255, 255, 255, 0.1)',
    background: '#271a2b',
  },

  // Spacing
  spacing: {
    xs: '8px',
    s: '12px',
    m: '16px',
    l: '24px',
    xl: '32px',
    xxl: '48px',
  },

  // Border radius
  borderRadius: {
    s: '8px',
    m: '12px',
    l: '16px',
  },

  // Transitions
  transitions: {
    normal: '0.3s ease',
    fast: '0.15s ease',
  },

  // Shadows
  shadows: {
    s: '0 2px 8px rgba(0, 0, 0, 0.1)',
    m: '0 4px 16px rgba(0, 0, 0, 0.15)',
    l: '0 8px 32px rgba(0, 0, 0, 0.2)',
  },

  // Font sizes
  fontSizes: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '24px',
    xxl: '36px',
  },
};

// Audio files mapping
export const AUDIO_FILES = {
  voice2: '/assets/sounds/voice2.mp3',
  voice3: '/assets/sounds/voice3.mp3',
  voice4: '/assets/sounds/voice4.mp3',
};

// Personality icons mapping
export const PERSONALITY_ICONS = {
  stepSis: '🧸',
  stepMom: '💝',
  girlfriend: '💕',
  sexFriend: '👥',
};

// Personality titles mapping
export const PERSONALITY_TITLES = {
  stepSis: 'personality.stepSis',
  stepMom: 'personality.stepMom',
  girlfriend: 'personality.girlfriend',
  sexFriend: 'personality.sexFriend',
};

// Personality V2 options (createsexfriend-isPersonality). Convenience export so
// readers can grab the visual-only set without going through DEFAULT_QUIZ_OPTIONS_DATA.
// Always go through getQuizOptionsData('personalityV2', style) to pick up GB overrides.
export const PERSONALITY_V2_OPTIONS = DEFAULT_QUIZ_OPTIONS_DATA.personalityV2;
